import {getElementStyleValues} from './getElementStyleValues';

// Regular expression to match scrollable `overflow` values
const regex = /(auto|scroll)/;

// Style properties to check for scrollable `overflow` values
const styleKeys = ['overflow', 'overflow-y', 'overflow-x'];

// Function to check if an element has scrollable overflow
const scroll = (element: Element) =>
	regex.test(getElementStyleValues(element, styleKeys).join(''));

/**
 * Get the closest scroll parent of an element.
 * @param element The element to get the closest scroll parent of
 * @returns The closest scroll parent. Will default to `document.body` if no scroll parent is found.
 *
 * @see https://gist.github.com/gre/296291b8ce0d8fe6e1c3ea4f1d1c5c3b
 *
 * @example
 * ```ts
 * const scrollParent = getScrollparent(element);
 * ```
 */
export const getScrollparent = (element: Element | null): Element =>
	!element || element === document.body
		? document.body
		: scroll(element)
		? element
		: getScrollparent(element.parentElement);
